import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import axios from '../../../library/axios';
import ArrayCell from '../../../helpers/listEpByIdDokumen';
import { MySwal } from '../../../library/swal';
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const ListDokumentEp = (props) => {

    // console.log(props)
    // Function to handle the download
    const downloadFile = (base64, fileName, mimeType) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDelete = (idDocument) => {
        console.log(idDocument)
        MySwal.fire({
            text: "Anda yakin untuk menghapus dokumen ini?",
            icon: "warning",
            buttonsStyling: false,
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: 'No',
            customClass: {
                confirmButton: "btn btn-light-primary",
                denyButton: "btn btn-danger"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const config = {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
                    },
                };
                axios
                    .delete(`/skor/delete-master-dokumen/${idDocument}`, config)
                    .then((res) => {
                        if (res.status === 200) {
                            MySwal.fire({
                                text: 'Dokumen sudah terhapus.',
                                icon: 'success',
                                confirmButtonText: "Ok",
                                buttonsStyling: false,
                                customClass: {
                                    confirmButton: "btn btn-light-primary"
                                }
                            });
                            props.handleClose()
                        }
                    })
                    .catch((err) => {
                        if (err !== '') console.log(err?.response?.data);
                    });
            } else if (result.isDenied) {
                MySwal.fire({
                    text: 'Dokumen tidak terhapus.',
                    icon: 'info',
                    confirmButtonText: "Ok",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-light-primary"
                    }
                });
                props.handleClose()
            }
        });
    }

    const columns = [
        {
            name: 'Aksi',
            width: '125px',
            cell: (row) => (
                <>
                    <span
                        role="button"
                        class="bi bi-trash text-danger pe-auto"
                        onClick={() => {
                            // handleElemen(row.id);
                            // handleShow();
                            handleDelete(row.master_document.id)
                        }}
                        title='Hapus Dokumen'
                    >

                    </span>
                </>
            )
        },
        {
            name: 'Referensi EP',
            width: '250px',
            wrap: true,
            cell: (row) => <ArrayCell row={row} />
        },
        {
            name: 'View',
            width: '125px',
            cell: (row) => (
                <>
                    <a id="downloadLink" href={row.master_document.dokumen} download={row.master_document.namaFile}>Download</a>
                </>
            )
        },
        {
            name: 'Nama File',
            width: '150px',
            cell: (row) => row.master_document.namaFile,
            selector: "Dokumen",
            sortable: true
        },
        {
            name: 'Deskripsi',
            width: '600px',
            cell: (row) => row.master_document.Deskripsi
        }
    ];

    return (
        <>
            <DataTable
                columns={columns}
                data={props?.data}
                pagination
                fixedHeader
                highlightOnHover
            />
        </>
    );

}


export default ListDokumentEp;
